<script>
    import { setContext } from 'svelte'
    let ctx = { 
        item: null, 
        from: null, 
        to  : null,
        reset: function() {
            this.item = null
            this.from = null
            this.to   = null
        } 
    } 
    setContext('ctx', ctx)
</script>

<slot></slot>